// c04 Bozor — boutique grand-opening catalog card.
//
// Paper-invitation energy with Madison-Avenue stationery feel: an outer
// amber foil mat with a double-hairline edge wraps a cream inner card;
// the focal element is a ribbon-and-shears medallion suggesting a ribbon
// cutting. Brand name renders in Bodoni Moda; the caption sits in small
// caps at the bottom.
import { Photo, type LayoutCtx } from "./_shared";

export function RetailOpeningLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
  photo,
}: LayoutCtx) {
  const foil = `linear-gradient(135deg, ${accent} 0%, color-mix(in srgb, ${accent} 60%, #fff 40%) 50%, ${accent} 100%)`;
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: foil,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}44`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          OCHILISH
        </div>

        {/* Ribbon-cutting medallion. */}
        <div
          style={{
            width: "60%",
            aspectRatio: "1 / 1",
            position: "relative",
            marginBottom: "5%",
            borderRadius: "50%",
            background: `radial-gradient(circle at 50% 45%, ${accent}1A, ${bg} 70%)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `inset 0 0 0 1px ${accent}66`,
            overflow: "hidden",
          }}
        >
          <Photo
            src={photo}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", borderRadius: "50%" }}
            fallback={
              <svg viewBox="0 0 100 100" style={{ width: "78%", height: "78%" }} aria-hidden>
                {/* Hairline ring */}
                <circle cx="50" cy="50" r="40" fill="none" stroke={accent} strokeWidth="0.5" opacity="0.55" />
                {/* Ribbon — horizontal band across the medallion */}
                <path
                  d="M14 50 L40 50 L48 42 L52 42 L60 50 L86 50 L80 56 L60 56 L52 50 L48 50 L40 56 L20 56 Z"
                  fill={accent}
                  opacity="0.75"
                />
                <path d="M44 48 L56 48 L54 52 L46 52 Z" fill={bg} opacity="0.85" />
                <path
                  d="M48 52 L44 70 L50 64 L52 72 L56 56"
                  fill={accent}
                  opacity="0.65"
                />
                <polygon
                  points="50,22 52,28 58,28 53,32 55,38 50,34 45,38 47,32 42,28 48,28"
                  fill={accent}
                  opacity="0.85"
                />
              </svg>
            }
          />
        </div>

        {/* Brand name — Bodoni display, slightly wider tracking. */}
        <div
          style={{
            fontFamily: font,
            fontSize: 28,
            lineHeight: 1.1,
            fontWeight: 500,
            letterSpacing: "0.08em",
            color: ink,
            textTransform: "uppercase",
          }}
        >
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          OCHILISH · {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
